import axiosInstance from '../../../../common/axios.service';
import {ADD_CHARGER, UPDATE_CHARGER} from './chargers.type';
import type FILTERS from '../../../../common/filters.type';

const chargersList = (values: FILTERS) => {
  return axiosInstance.get('charger', {params: values}).then((response) => {
    return response;
  });
};

const addCharger = (values: ADD_CHARGER) => {
  return axiosInstance.post('charger', values).then((response) => {
    return response;
  });
};

const updateCharger = (values: {id: number; payload: UPDATE_CHARGER}) => {
  return axiosInstance.put(`charger/${values.id}`, values.payload).then((response) => {
    return response;
  });
};

const chargersServices = {
  chargersList,
  addCharger,
  updateCharger,
};

export default chargersServices;
